const HELP_CENTER_LINKS: Record<string, Record<string, string>> = {
  essential_handbook: {
    en: '/managers-manual',
    de: '/de/factorial-handbuch-für-vorgesetzte',
    es: '/es/guía-para-managers',
    fr: '/fr/manuel-des-gestionnaires',
    it: '/it/manuale-per-i-manager',
    pt: '/pt-br/manual-do-gestor',
    'pt-br': '/pt-br/manual-do-gestor',
    'en-gb': '/managers-manual',
    'es-mx': '/es/guía-para-managers',
    'es-ar': '/es/guía-para-managers',
    'es-cl': '/es/guía-para-managers',
    'es-co': '/es/guía-para-managers',
  },
  time_tracking_guide: {
    en: '/time-tracking-guide',
    de: '/de/zeiterfassungsanleitung',
    es: '/es/guía-de-control-horario',
    fr: '/fr/guide-de-suivi-du-temps',
    it: '/it/guida-alla-rilevazione-presenze',
    pt: '/pt-br/guia-de-controle-de-frequência',
    'pt-br': '/pt-br/guia-de-controle-de-frequência',
    'en-gb': '/time-tracking-guide',
    'es-mx': '/es/guía-de-control-horario',
    'es-ar': '/es/guía-de-control-horario',
    'es-cl': '/es/guía-de-control-horario',
    'es-co': '/es/guía-de-control-horario',
  },
  time_planning_tools: {
    en: '/time-planning-tools',
    de: '/de/tools-zur-zeitplanung',
    es: '/es/herramientas-de-planificación-de-tiempos',
    fr: '/fr/outils-de-planification-du-temps',
    it: '/it/strumenti-di-pianificazione-del-tempo',
    pt: '/pt-br/ferramenta-planejamento-de-tempo',
    'pt-br': '/pt-br/ferramenta-planejamento-de-tempo',
    'en-gb': '/time-planning-tools',
    'es-mx': '/es/herramientas-de-planificación-de-tiempos',
    'es-ar': '/es/herramientas-de-planificación-de-tiempos',
    'es-cl': '/es/herramientas-de-planificación-de-tiempos',
    'es-co': '/es/herramientas-de-planificación-de-tiempos',
  },
  time_off_guide: {
    en: '/a-brief-guide-about-time-off',
    de: '/de/eine-kurze-anleitung-über-abwesenheiten',
    es: '/es/soy-un-empleado-puedo-modificar-una-solicitud-de-ausencia',
    fr: '/fr/un-petit-guide-sur-les-congés',
    it: '/it/una-breve-guida-sulle-assenze',
    pt: '/pt-br/um-breve-guia-sobre-ausências',
    'pt-br': '/pt-br/um-breve-guia-sobre-ausências',
    'en-gb': '/a-brief-guide-about-time-off',
    'es-mx': '/es/soy-un-empleado-puedo-modificar-una-solicitud-de-ausencia',
    'es-ar': '/es/soy-un-empleado-puedo-modificar-una-solicitud-de-ausencia',
    'es-cl': '/es/soy-un-empleado-puedo-modificar-una-solicitud-de-ausencia',
    'es-co': '/es/soy-un-empleado-puedo-modificar-una-solicitud-de-ausencia',
  },
  permissions_guide: {
    en: '/short-guide-to-permissions',
    de: '/de/eine-kurze-anleitung-zu-berechtigungen',
    es: '/es/guía-de-permisos',
    fr: '/fr/petit-guide-des-droits-daccès',
    it: '/it/breve-guida-alle-autorizzazioni',
    pt: '/pt-br/breve-guia-de-permissões',
    'pt-br': '/pt-br/breve-guia-de-permissões',
    'en-gb': '/short-guide-to-permissions',
    'es-mx': '/es/guía-de-permisos',
    'es-ar': '/es/guía-de-permisos',
    'es-cl': '/es/guía-de-permisos',
    'es-co': '/es/guía-de-permisos',
  },
  download_factorial: {
    en: '/factorial-app-for-smartphones',
    de: '/de/factorial-app-für-smartphones',
    es: '/es/ya-tenemos-app-para-smartphones',
    fr: '/fr/application-pour-smartphones-sur-factorial',
    it: '/it/app-factorial-per-smartphone',
    pt: '/pt-br/aplicativo-da-factorial-para-dispositivos-móveis',
    'pt-br': '/pt-br/aplicativo-da-factorial-para-dispositivos-móveis',
    'en-gb': '/factorial-app-for-smartphones',
    'es-mx': '/es/ya-tenemos-app-para-smartphones',
    'es-ar': '/es/ya-tenemos-app-para-smartphones',
    'es-cl': '/es/ya-tenemos-app-para-smartphones',
    'es-co': '/es/ya-tenemos-app-para-smartphones',
  },
  about_time_off_counters: {
    en: '/about-time-off-counters',
    de: '/de/erklärung-der-abwesenheitszähler',
    es: '/es/sobre-los-contadores-de-ausencias',
    fr: '/fr/a-propos-des-compteurs-dabsences',
    it: '/it/info-sui-contatori-delle-assenze-1',
    pt: '/pt-br/sobre-contadores-de-ausencias',
    'pt-br': '/pt-br/sobre-contadores-de-ausencias',
    'en-gb': '/about-time-off-counters',
    'es-mx': '/es/sobre-los-contadores-de-ausencias',
    'es-ar': '/es/sobre-los-contadores-de-ausencias',
    'es-cl': '/es/sobre-los-contadores-de-ausencias',
    'es-co': '/es/sobre-los-contadores-de-ausencias',
  },
  create_and_assign_timeoff_policies: {
    en: '/configure-your-company-time-off-policies',
    de: '/de/abwesenheitsrichtlinien-konfigurieren',
    es: '/es/cómo-configurar-las-políticas-de-ausencia-de-tu-empresa',
    fr: '/fr/comment-créer-et-attribuer-des-politiques-de-congés',
    it: '/it/come-creare-e-assegnare-politiche-di-assenza',
    pt: '/pt-br/como-criar-e-atribuir-politicas-de-ausencias',
    'pt-br': '/pt-br/como-criar-e-atribuir-politicas-de-ausencias',
    'en-gb': '/configure-your-company-time-off-policies',
    'es-mx': '/es/cómo-configurar-las-políticas-de-ausencia-de-tu-empresa',
    'es-ar': '/es/cómo-configurar-las-políticas-de-ausencia-de-tu-empresa',
    'es-cl': '/es/cómo-configurar-las-políticas-de-ausencia-de-tu-empresa',
    'es-co': '/es/cómo-configurar-las-políticas-de-ausencia-de-tu-empresa',
  },
  export_time_tracking_reports: {
    en: '/how-to-export-a-time-tracking-report',
    de: '/de/herunterladen-des-zeiterfassungsberichtes',
    es: '/es/descarga-el-informe-de-control-horario',
    fr: '/fr/comment-exporter-un-rapport-de-suivi-du-temps',
    it: '/it/come-esportare-il-report-della-rilevazione-presenze',
    pt: '/pt-br/descarregue-o-relatório-de-controlo-horário',
    'pt-br': '/pt-br/descarregue-o-relatório-de-controlo-horário',
    'en-gb': '/how-to-export-a-time-tracking-report',
    'es-mx': '/es/descarga-el-informe-de-control-horario',
    'es-ar': '/es/descarga-el-informe-de-control-horario',
    'es-cl': '/es/descarga-el-informe-de-control-horario',
    'es-co': '/es/descarga-el-informe-de-control-horario',
  },
  export_time_off_reports: {
    en: '/download-the-time-off-report-of-your-employees',
    de: '/de/einen-abwesenheitsbericht-herunterladen',
    es: '/es/recoge-las-ausencias-de-tus-empleados-en-un-excel',
    fr: '/fr/comment-exporter-le-rapport-de-congés-de-vos-collaborateurs',
    it: '/it/come-esportare-il-report-delle-assenze-dei-tuoi-dipendenti',
    pt: '/pt-br/descarregue-o-relatório-de-ausências-dos-seus-colaboradores',
    'pt-br': '/pt-br/descarregue-o-relatório-de-ausências-dos-seus-colaboradores',
    'en-gb': '/download-the-time-off-report-of-your-employees',
    'es-mx': '/es/recoge-las-ausencias-de-tus-empleados-en-un-excel',
    'es-ar': '/es/recoge-las-ausencias-de-tus-empleados-en-un-excel',
    'es-cl': '/es/recoge-las-ausencias-de-tus-empleados-en-un-excel',
    'es-co': '/es/recoge-las-ausencias-de-tus-empleados-en-un-excel',
  },
  about_overtime_compensation_with_time_off: {
    en: '/about-overtime-compensation-with-time-off',
    de: '/about-overtime-compensation-with-time-off',
    es: '/es/compensación-de-horas-extras-con-bolsa-de-horas',
    fr: '/fr/à-propos-de-la-rémunération-des-heures-supplémentaires-avec-congé',
    it: '/it/info-sulla-retribuzione-degli-straordinari-con-ferie',
    pt: '/pt-br/compensaçao-de-horas-extras-com-ausencias-atraves-do-banco-de-horas',
    'pt-br': '/pt-br/compensaçao-de-horas-extras-com-ausencias-atraves-do-banco-de-horas',
    'en-gb': '/about-overtime-compensation-with-time-off',
    'es-mx': '/es/compensación-de-horas-extras-con-bolsa-de-horas',
    'es-ar': '/es/compensación-de-horas-extras-con-bolsa-de-horas',
    'es-cl': '/es/compensación-de-horas-extras-con-bolsa-de-horas',
    'es-co': '/es/compensación-de-horas-extras-con-bolsa-de-horas',
  },
  about_overtime_compensation_with_payroll: {
    en: '/about-overtime-compensation-through-payroll',
    de: '/about-overtime-compensation-through-payroll',
    es: '/es/compensación-de-horas-extra-mediante-la-nómina',
    fr: '/fr/compensation-des-heures-supplémentaires-avec-levp',
    it: '/it/info-sulla-retribuzione-degli-straordinari-tramite-busta-paga',
    pt: '/pt-br/compensação-de-horas-extras-com-folha-de-pagamento',
    'pt-br': '/pt-br/compensação-de-horas-extras-com-folha-de-pagamento',
    'en-gb': '/about-overtime-compensation-through-payroll',
    'es-mx': '/es/compensación-de-horas-extra-mediante-la-nómina',
    'es-ar': '/es/compensación-de-horas-extra-mediante-la-nómina',
    'es-cl': '/es/compensación-de-horas-extra-mediante-la-nómina',
    'es-co': '/es/compensación-de-horas-extra-mediante-la-nómina',
  },
  about_hour_estimation_and_balance: {
    en: '/about-estimated-hours-and-hours-balance',
    de: '/de/arbeitszeit-saldo',
    es: '/es/contabiliza-el-balance-de-horas-de-tus-empleados',
    fr: '/fr/à-propos-des-heures-estimées-et-du-solde-dheures',
    it: '/it/info-sulle-ore-stimate-e-sul-saldo-delle-ore',
    pt: '/pt-br/veja-o-balanço-de-horas',
    'pt-br': '/pt-br/veja-o-balanço-de-horas',
    'en-gb': '/about-estimated-hours-and-hours-balance',
    'es-mx': '/es/contabiliza-el-balance-de-horas-de-tus-empleados',
    'es-ar': '/es/contabiliza-el-balance-de-horas-de-tus-empleados',
    'es-cl': '/es/contabiliza-el-balance-de-horas-de-tus-empleados',
    'es-co': '/es/contabiliza-el-balance-de-horas-de-tus-empleados',
  },
  how_to_clock_in_desktop: {
    en: '/how-to-clock-inout-on-desktop',
    de: '/de/zeiterfassungssysteme',
    es: '/es/sobre-de-los-sistemas-de-control-horario',
    fr: '/fr/comment-pointer-les-entrées/sorties-sur-le-bureau',
    it: '/it/come-timbrare-lentrata-uscita-da-desktop',
    pt: '/pt-br/primeiros-passos-do-relógio-de-ponto',
    'pt-br': '/pt-br/primeiros-passos-do-relógio-de-ponto',
    'en-gb': '/how-to-clock-inout-on-desktop',
    'es-mx': '/es/sobre-de-los-sistemas-de-control-horario',
    'es-ar': '/es/sobre-de-los-sistemas-de-control-horario',
    'es-cl': '/es/sobre-de-los-sistemas-de-control-horario',
    'es-co': '/es/sobre-de-los-sistemas-de-control-horario',
  },
  how_to_clock_in_qr: {
    en: '/how-to-clock-inout-with-the-qr-code',
    de: '/de/ein-und-ausstempeln-über-einen-qr-code',
    es: '/es/cómo-utilizar-el-fichaje-con-código-qr-en-factorial',
    fr: '/fr/comment-pointer-les-entrées/sorties-avec-le-code-qr',
    it: '/it/come-timbrare-lentrata-uscita-con-il-codice-qr',
    pt: '/pt-br/como-usar-o-qr-code-para-registar-a-hora-de-entrada/-saída',
    'pt-br': '/pt-br/como-usar-o-qr-code-para-registar-a-hora-de-entrada/-saída',
    'en-gb': '/how-to-clock-inout-with-the-qr-code',
    'es-mx': '/es/cómo-utilizar-el-fichaje-con-código-qr-en-factorial',
    'es-ar': '/es/cómo-utilizar-el-fichaje-con-código-qr-en-factorial',
    'es-cl': '/es/cómo-utilizar-el-fichaje-con-código-qr-en-factorial',
    'es-co': '/es/cómo-utilizar-el-fichaje-con-código-qr-en-factorial',
  },
  how_to_clock_in_face_recognition: {
    en: '/how-to-clock-inout-with-face-recognition',
    de: '/de/gesichtserkennung-einrichten-mitarbeiter',
    es: '/es/cómo-configuro-el-reconocimiento-facial',
    fr: '/fr/comment-pointer-les-entrées/sorties-avec-la-reconnaissance-faciale',
    it: '/it/come-timbrare-lentrata-uscita-con-il-riconoscimento-facciale',
    pt: '/pt-br/como-faço-para-configurar-o-reconhecimento-facial',
    'pt-br': '/pt-br/como-faço-para-configurar-o-reconhecimento-facial',
    'en-gb': '/how-to-clock-inout-with-face-recognition',
    'es-mx': '/es/cómo-configuro-el-reconocimiento-facial',
    'es-ar': '/es/cómo-configuro-el-reconocimiento-facial',
    'es-cl': '/es/cómo-configuro-el-reconocimiento-facial',
    'es-co': '/es/cómo-configuro-el-reconocimiento-facial',
  },
  how_to_clock_in_id: {
    en: '/how-to-clock-inout-by-id',
    de: '/de/einstempeln-mit-identifikationsnummer',
    es: '/es/cómo-realizar-el-fichaje-con-el-dni',
    fr: '/fr/comment-pointer-les-entrées/sorties-par-id',
    it: '/it/come-timbrare-lentratauscita-tramite-id',
    pt: '/pt-br/como-registrar-entrada-com-o-número-de-identificação',
    'pt-br': '/pt-br/como-registrar-entrada-com-o-número-de-identificação',
    'en-gb': '/how-to-clock-inout-by-id',
    'es-mx': '/es/cómo-realizar-el-fichaje-con-el-dni',
    'es-ar': '/es/cómo-realizar-el-fichaje-con-el-dni',
    'es-cl': '/es/cómo-realizar-el-fichaje-con-el-dni',
    'es-co': '/es/cómo-realizar-el-fichaje-con-el-dni',
  },
  document_templates_article: {
    en: '/about-document-templates',
    de: '/de/dokumentvorlagen',
    es: '/es/plantillas-de-documentos',
    fr: '/fr/a-propos-des-modeles-de-documents',
    it: '/it/modelli-di-documenti',
    pt: '/pt-br/modelos-de-documentos',
    'pt-br': '/pt-br/modelos-de-documentos',
    'en-gb': '/about-document-templates',
    'es-mx': '/es/plantillas-de-documentos',
    'es-ar': '/es/plantillas-de-documentos',
    'es-cl': '/es/plantillas-de-documentos',
    'es-co': '/es/plantillas-de-documentos',
  },
}

type HelpCenterLink = keyof typeof HELP_CENTER_LINKS

export function getHelpCenterLocalizedLink(locale: string, linkKey: HelpCenterLink): string {
  const localeFallback = 'en'
  const helpCenterLink = HELP_CENTER_LINKS[linkKey]

  if (!helpCenterLink) {
    return ''
  }

  const localizedLink = helpCenterLink[locale] || helpCenterLink[localeFallback]

  if (!localizedLink) {
    return ''
  }

  return `https://help.factorialhr.com${localizedLink}`
}
